import { FC, useCallback, useContext } from 'react';
import HeaderComponent from '@components/HeaderComponent/HeaderComponent';
import BackgroundImage from '@resources/images/home-banner.jpg';
import FooterComponent from '@components/FooterComponent/FooterComponent';
import { Stack, Text, Button } from '@chakra-ui/react';
import * as Icons from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '@routes/appRoutes';
import palette from '@theme/assets/palette';
import { StoreContext } from '@contexts/StoreContext';
import { StoreContextType } from 'types/reducers';

const HomePage: FC = () => {
    const navigate = useNavigate();
    const { state } = useContext<StoreContextType>(StoreContext);

    const DynamicMdIcon = useCallback((name: string) => {
        // @ts-ignore
        const IconComponent = Icons[name];

        if (!IconComponent) {
            // Return a default one
            return <Icons.MdHome />;
        }

        return <IconComponent />;
    }, []);

    const handleNavigate = useCallback(
        (link: string) => {
            navigate(link);
        },
        [navigate],
    );

    return (
        <Stack minHeight="100vh" gap="0">
            <HeaderComponent
                title="Nuova anagrafica"
                subtitle="Incomincia scegliendo il tipo di anagrafica da creare"
                backgroundImg={BackgroundImage}
            />
            <Stack
                direction="row"
                justify="center"
                align="flex-start"
                spacing="0px"
                alignSelf="stretch"
                background="gray.50"
                flex="1"
            >
                <Stack
                    paddingX="100px"
                    paddingTop="30px"
                    paddingBottom="90px"
                    justify="center"
                    align="center"
                    spacing="20px"
                    width="533px"
                    alignSelf="stretch"
                    maxWidth="100%"
                >
                    <Stack
                        paddingTop="30px"
                        paddingBottom="20px"
                        justify="center"
                        align="center"
                        spacing="10px"
                        alignSelf="stretch"
                    >
                        <Text variant="titleL" color={palette.ui02} alignSelf="stretch" textAlign="center">
                            Cliente
                        </Text>
                        <Text variant="subtitle" color={palette.ui02} alignSelf="stretch" textAlign="center">
                            Nuova anagrafica cliente
                        </Text>
                    </Stack>
                    <Stack direction="column" justify="center" align="center" spacing="10px" alignSelf="stretch">
                        <Button
                            leftIcon={DynamicMdIcon('MdPerson')}
                            size="lg"
                            variant={'main'}
                            onClick={() => handleNavigate(`${AppRoutes.NEW_CUSTOMER_PAGE}italy`)}
                        >
                            Cliente italiano
                        </Button>
                        <Button
                            leftIcon={DynamicMdIcon('MdPerson')}
                            size="lg"
                            variant={'main'}
                            onClick={() => handleNavigate(`${AppRoutes.NEW_CUSTOMER_PAGE}eu`)}
                        >
                            Cliente UE
                        </Button>
                        <Button
                            leftIcon={DynamicMdIcon('MdPerson')}
                            size="lg"
                            variant={'main'}
                            onClick={() => handleNavigate(`${AppRoutes.NEW_CUSTOMER_PAGE}extra-eu`)}
                        >
                            Cliente Extra UE
                        </Button>
                    </Stack>
                </Stack>
                <Stack
                    paddingX="100px"
                    paddingTop="30px"
                    paddingBottom="90px"
                    justify="center"
                    align="center"
                    spacing="20px"
                    flex="1"
                    background="white"
                    boxShadow="xl"
                    alignSelf="stretch"
                >
                    <Stack
                        paddingTop="30px"
                        paddingBottom="20px"
                        justify="center"
                        align="center"
                        spacing="10px"
                        alignSelf="stretch"
                    >
                        <Text variant="titleL" color={palette.ui02} alignSelf="stretch" textAlign="center">
                            Fornitore
                        </Text>
                        <Text variant="subtitle" color={palette.ui02} alignSelf="stretch" textAlign="center">
                            Scegli il tipo fornitore per cui crea la nuova anagrafica
                        </Text>
                    </Stack>
                    <Stack
                        direction="row"
                        justify="center"
                        align="flex-start"
                        spacing="10px"
                        alignSelf="stretch"
                        flexWrap="wrap"
                        maxW="700px"
                        margin="0 auto"
                    >
                        {state.supplierItems.map((supplier) => {
                            return (
                                <Button
                                    leftIcon={DynamicMdIcon(supplier.icon)}
                                    size="lg"
                                    key={supplier.id}
                                    backgroundColor={supplier.color}
                                    variant={'main'}
                                    onClick={() =>
                                        handleNavigate(`${AppRoutes.SUPPLIER_FORM_PAGE}${supplier.tag.toLowerCase()}`)
                                    }
                                >
                                    {supplier.name}
                                </Button>
                            );
                        })}
                    </Stack>
                </Stack>
            </Stack>
            <FooterComponent />
        </Stack>
    );
};

export default HomePage;
